<template>
  <div class="play-line-chart">
    <div class="graph-radio-wrap">
      <el-radio-group v-model="dataType" @change="dataTypeChange">
        <el-radio :label="name + '总量'">{{ name }}总量</el-radio>
        <el-radio :label="name + '增量'">{{ name }}增量</el-radio>
      </el-radio-group>
    </div>
    <div :id="id + 'LineChart'" style="width: 100%;height: 500px;"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import util from "@/util/util";
export default {
  name: 'playLineGraph',
  props: {
    gData: Object,
    id: String,
    name: String,
    ylabel: String
  },
  data () {
    return {
      charts: '',
      xAxisList: [],
      valList: [],
      valIncreList: [],
      dataType: this.name + '总量'
    }
  },
  created() {
    this.initData(this.gData);
  },
  mounted() {
    this.$nextTick(function() {
      this.drawLine(this.id + 'LineChart');
    })
  },
  methods: {
    initData(data) {
      this.valList = [];
      this.valIncreList = [];
      this.xAxisList = [];
      for (let k in data) {
        this.xAxisList.push(k);
        this.valList.push(data[k].val);
        this.valIncreList.push(data[k].increVal);
      }
    },
    drawLine(id) {
      var that = this;
      let data = that.dataType == that.name + '增量' ? that.valIncreList : that.valList;
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },

        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: that.xAxisList,
          splitLine: {
            show: false
          },
          nameTextStyle: {
            color: "rgb(50, 52, 55)",
            fontSize: 12,
            fontStyle: "normal"
          },
          scale: true,
          boundaryGap: false,
          axisLabel: {
            textStyle: {
              color: "rgb(50, 52, 55)",
              fontSize: 12,
              fontStyle: "normal"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: function (val) {
              return that.subDate(val, ['H', 'm']);
            }
          }
        },
        yAxis: {
          type: 'value',
          name: that.ylabel,
          nameTextStyle: {
            fontWeight: 'bold'
          }
        },
        dataZoom: [
          {
            type: 'inside',
            start: 30,
            end: 70
          }, {
            start: 30,
            end: 70,
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%',
            handleStyle: {
              color: '#fff',
              shadowBlur: 3,
              shadowColor: 'rgba(0, 0, 0, 0.6)',
              shadowOffsetX: 2,
              shadowOffsetY: 2
            }
          }
        ],
        toolbox: {
          feature: {
            saveAsImage: {
              show: false
            }
          }
        },
        series: [
          {
            name: that.dataType,
            type: 'line',
            stack: that.dataType,
            data,
            itemStyle: {
              normal: {
                color: 'orange',
                lineStyle: {
                  color: 'orange'
                }
              }
            }
          }
        ]
      }, true)
    },
    dataTypeChange() {
      this.$nextTick(function() {
        this.drawLine(this.id + 'LineChart');
      })
    },
    /**
     * 截取时间
     * @param date 需要截取的完整时间
     * @param range 数组[a,b] a,b属于['y', 'M', 'd', 'H', 'm', 's']
     */
    subDate(date, range) {
      return util.subDate(date, range);
    },
  },
  watch: {
    gData: {
      handler(newVal, oldVal) {
        // console.log('newVal', newVal)
        // this.initData(newVal);
      },
      deep: true
    },
    id(newVal, oldVal) {

    },
    name(newVal, oldVal) {

    },
    ylabel(newVal, oldVal) {

    }
  }
}
</script>

<style lang="scss">
.graph-radio-wrap {
  padding-right: 4%;
  text-align: right;
  .el-radio__input.is-checked+.el-radio__label,
  .el-radio__input.is-checked .el-radio__inner {
    color: orange;
  }
  .el-radio__input.is-checked .el-radio__inner,
  .el-radio__inner:hover {
    
    border-color:orange;
    background: orange;
  }
}
</style>